var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { transient, autoinject, bindable } from "aurelia-framework";
import "amcharts3";
import "amcharts3/amcharts/pie.js";
import "amcharts3/amcharts/serial.js";
import "amcharts3/amcharts/gauge.js";
import "amcharts3/amcharts/funnel.js";
import "amcharts3/amcharts/plugins/export/export.js";
import "amcharts3/amcharts/plugins/animate/animate.js";
import "amcharts3/amcharts/plugins/dataloader/dataloader.js";
import "amcharts3/amcharts/plugins/responsive/responsive.js";
import "amcharts3/amcharts/plugins/export/libs/blob.js/blob.js";
import "amcharts3/amcharts/plugins/export/libs/FileSaver.js/FileSaver.js";
import "amcharts3/amcharts/plugins/export/libs/jszip/jszip.min.js";
import "amcharts3/amcharts/plugins/export/libs/classList.js/classList.min.js";
import { Guid } from "../../../utilities/guid";
import * as Enumerable from "linq";
import moment from "moment";
import 'print-this';
var Chart = /** @class */ (function () {
    function Chart(element) {
        this.element = element;
        this.cdnWidgetImages = __CDN_WIDGET_IMAGES__;
        this.id = Guid.generateGuid();
        this.canZoom = true;
        this.noDataLabel = "No Data Available";
        this.showNoDataIfZero = false;
        this.isDefaultLegendVisible = false;
        this.fontSize = 11;
        this.exportEnabled = true;
        this.responsive = false;
        this.formatTooltip = "[[label]]: [[formatData]]";
        this.title = "";
        this.labelFrequency = 2;
        this.orderBy = "descending";
        this.dateFormat = "DD/MM/YYYY";
        var colors = ["#9ee6d2", "#65baf9", "#6dc3c3", "#3379ae", "#e3b7f4", "#ecacac", "#df6262", "#93bf63",
            "#f0be45", "#9ca6e2", "#9fb3b7", "#5e656c"];
        // this.colors = colors;
        this.colors = this.shuffle(colors);
    }
    Chart.prototype.attached = function () {
        this._attachedToDOM = true;
        this.refresh();
    };
    Chart.prototype.dataEntriesChanged = function () {
        this.refresh();
    };
    Chart.prototype.typeChanged = function () {
        this.refresh();
    };
    Chart.prototype.getHasData = function () {
        var hasData = this.dataEntries && this.type
            && this.dataEntries.chartDataEntries
            && this.dataEntries.chartDataEntries.length > 0;
        //added for stacked charts where there are results from multiple queries to check if the there is any data in chart data entries 
        hasData = hasData && Enumerable.from(this.dataEntries.chartDataEntries)
            .any(function (x) {
            return x.data != null &&
                ((Array.isArray(x.data) && x.data.length > 0) || !Array.isArray(x.data));
        });
        return hasData;
    };
    Chart.prototype.refresh = function (onlyDataRefresh) {
        var e_1, _a, e_2, _b;
        var _this = this;
        if (onlyDataRefresh === void 0) { onlyDataRefresh = false; }
        this.hasData = this.getHasData();
        if (this.hasData && this._attachedToDOM) {
            if (onlyDataRefresh) {
                this.chart.dataProvider = this.getDataProvider();
                this.chart.validateData();
            }
            var barCharts = [ChartTypes.Bar, ChartTypes.HorizontalBar, ChartTypes.StackedBar, ChartTypes.StackedHorizontalBar];
            var lineCharts = [ChartTypes.AreaChart, ChartTypes.Line];
            var pie = [ChartTypes.Pie, ChartTypes.Donut];
            var gauge = [ChartTypes.SolidGauge];
            var funnel = [ChartTypes.Funnel];
            var serial = barCharts.concat(lineCharts);
            var baseType = serial.indexOf(this.type) != -1 ? ChartBaseTypes.Serial :
                pie.indexOf(this.type) != -1 ? ChartBaseTypes.Pie :
                    gauge.indexOf(this.type) != -1 ? ChartBaseTypes.Gauge :
                        funnel.indexOf(this.type) != -1 ? ChartBaseTypes.Funnel :
                            "";
            if (!baseType)
                return;
            if (baseType == ChartBaseTypes.Funnel) {
                // if its a funnel add the total of the dataset
                // var data = Enumerable.from(this.dataEntries.chartDataEntries).sum(x => Number(x.data));
                // this.dataEntries.chartDataEntries.splice(0, 0, {
                //     label: "All",
                //     data: data,
                //     formatData: Number(data.toFixed(2)).toString()
                // })
            }
            var tempColors = this.colors.slice(0);
            try {
                // set color
                for (var _c = __values(this.dataEntries.chartDataEntries), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var x = _d.value;
                    if (!x.color) {
                        if (tempColors.length <= 0)
                            tempColors = this.shuffle(this.colors.slice(0));
                        var colorIndex = Math.floor(Math.random() * tempColors.length);
                        x.color = tempColors[colorIndex];
                        tempColors.splice(colorIndex, 1);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var options = {
                hideCredits: true,
                path: "dist/".concat(window["version"], "/amcharts/"),
                type: baseType,
                colors: this.colors,
                fontSize: this.fontSize,
                startEffect: 'easeOutSine',
                startDuration: 0.5,
                sequencedAnimation: true,
                responsive: {
                    enabled: this.responsive
                },
                balloon: {
                    fillAlpha: 1
                },
                export: {
                    enabled: this.exportEnabled,
                    divId: this.exportDivId
                }
            };
            //Zoom
            if (this.canZoom) {
                options.chartCursor = {
                    categoryBalloonEnabled: false,
                    cursorAlpha: 0.2,
                    zoomable: true
                };
            }
            //legend
            if (this.isDefaultLegendVisible) {
                options.legend = {
                    position: "right"
                };
            }
            // Chart Options
            this.baseChartConfiguration(baseType, options, lineCharts, barCharts);
            this.concreteChartConfiguration(this.type, options);
            if (this.chart) {
                if (this.chart.AmExport) {
                    this.chart.AmExport.setup.menu.parentNode.removeChild(this.chart.AmExport.setup.menu);
                    this.chart.AmExport.clear();
                }
                this.chart.clear();
            }
            var paramsEvent = { detail: { options: options }, bubbles: true };
            var customEv = new CustomEvent("options-built", paramsEvent);
            this.element.dispatchEvent(customEv);
            this.chart = window["AmCharts"].makeChart("chartdiv-".concat(this.id), options);
            this.chart.export.toPRINT = function (options, callback) {
                $(_this.element.parentElement.innerHTML).printThis();
            };
            if (baseType == ChartBaseTypes.Serial) {
                try {
                    for (var _e = __values(options.graphs), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var graph = _f.value;
                        if (!graph || !graph.addListener)
                            continue;
                        graph.addListener("clickGraphItem", function (event) {
                            var paramsEvent = { detail: { label: event.item.category, index: event.graph.index }, bubbles: true };
                            var chartItemClick = new CustomEvent("chart-item-click", paramsEvent);
                            _this.element.dispatchEvent(chartItemClick);
                        });
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            else if (baseType == ChartBaseTypes.Pie || baseType == ChartBaseTypes.Funnel) {
                //this.chart.chartData[0].dataContext.label
                this.chart.addListener("clickSlice", function (event) {
                    var paramsEvent = { detail: { label: event.dataItem.dataContext.label, index: 0, all: (baseType == ChartBaseTypes.Funnel && event.dataItem.dataContext.label.toLowerCase() == "all") }, bubbles: true };
                    var chartItemClick = new CustomEvent("chart-item-click", paramsEvent);
                    _this.element.dispatchEvent(chartItemClick);
                });
            }
        }
    };
    Chart.prototype.concreteChartConfiguration = function (type, options) {
        if (type == ChartTypes.HorizontalBar || type == ChartTypes.StackedHorizontalBar)
            options.rotate = true;
        else if (type == ChartTypes.AreaChart) {
            options.categoryAxis.labelFrequency = this.labelFrequency;
            options.chartScrollbar = {
                scrollbarHeight: 40,
                backgroundAlpha: 0,
                selectedBackgroundAlpha: 0.1,
                selectedBackgroundColor: "#888888",
                graphFillAlpha: 0,
                graphLineAlpha: 0.5,
                selectedGraphFillAlpha: 0,
                selectedGraphLineAlpha: 1,
                autoGridCount: false,
                gridCount: 5,
                color: "#AAAAAA",
            };
        }
        else if (type == ChartTypes.Line) {
            options.categoryAxis.labelFrequency = this.labelFrequency;
        }
        if (type == ChartTypes.StackedHorizontalBar || type == ChartTypes.StackedBar) {
            // options.valueAxes = [{
            //     stackType: "regular"
            // }];
        }
    };
    Chart.prototype.baseChartConfiguration = function (baseType, options, lineCharts, barCharts) {
        var e_3, _a;
        var _this = this;
        if (baseType == ChartBaseTypes.Serial) {
            //Serial
            options.categoryField = "label";
            options.categoryAxis = {
                gridPosition: "start",
                labelRotation: 45,
                labelFunction: function (valueText, serialDataItem, categoryAxis) {
                    if (valueText && valueText.trim().length > 11)
                        return valueText.substring(0, 10) + '...';
                    else
                        return valueText;
                }
            };
            options.graphs = this.dataEntries.labels ?
                this.dataEntries.chartDataEntries.map(function (x) {
                    var baloonText = "".concat(x.label ? x.label + ' : ' : '', "[[").concat(x.label, "-formatData]]");
                    if (_this.type == ChartTypes.StackedBar || _this.type == ChartTypes.StackedHorizontalBar) {
                        baloonText = "".concat(x.label ? x.label + ' : ' : '', "[[").concat(x.label, "-formatDataStacked]]");
                    }
                    return {
                        fillColorsField: "".concat(x.label, "-color"),
                        fillAlphas: _this.type == ChartTypes.AreaChart ? 0.4 : lineCharts.indexOf(_this.type) != -1 ? 0 : 1,
                        lineAlpha: barCharts.indexOf(_this.type) != -1 ? 0 : 1,
                        balloonText: baloonText,
                        title: x.label,
                        valueField: "".concat(x.label, "-data"),
                        labelText: "[[".concat(x.label, "-data]]"),
                        type: _this.getType(_this.type),
                        animationPlayed: true,
                        lineThickness: 3
                    };
                })
                : [
                    {
                        fillColorsField: "color",
                        fillAlphas: this.type == ChartTypes.AreaChart ? 0.4 : lineCharts.indexOf(this.type) != -1 ? 0 : 1,
                        lineAlpha: barCharts.indexOf(this.type) != -1 ? 0 : 1,
                        balloonText: this.formatTooltip,
                        valueField: "data",
                        labelText: "[[data]]",
                        type: this.getType(this.type),
                        animationPlayed: true,
                        lineThickness: 3
                    }
                ];
        }
        else if (baseType == ChartBaseTypes.Pie) {
            //Pie
            options.innerRadius = this.type == ChartTypes.Donut ? "50%" : "0%";
            options.labelText = "".concat(this.formatTooltip, " ([[percents]]%)");
            options.balloonText = "".concat(this.formatTooltip, " ([[percents]]%)");
            options.titleField = "label";
            options.colorField = "color";
            options.valueField = "data";
        }
        else if (baseType == ChartBaseTypes.Funnel) {
            //Funnel
            options.colorField = "color";
            options.valueField = "data";
            options.titleField = "label";
            options.depth3D = 1;
            options.marginRight = 240;
            options.angle = 40;
            options.outlineAlpha = 1;
            options.outlineColor = "#FFFFFF";
            options.outlineThickness = 2;
            options.labelPosition = "right";
            options.balloonText = "[[label]]: [[data]]";
        }
        if (baseType == ChartBaseTypes.Pie
            || baseType == ChartBaseTypes.Funnel
            || baseType == ChartBaseTypes.Serial) {
            if (this.orderBy && this.orderBy.trim() != "") {
                this.dataEntries.chartDataEntries = (this.orderBy == "descending" ?
                    Enumerable.from(this.dataEntries.chartDataEntries).orderByDescending(function (x) { return !isNaN(parseFloat(x.data.toString())) && isFinite(Number(x.data)) ? Number(x.data) : x.data; }) :
                    Enumerable.from(this.dataEntries.chartDataEntries).orderBy(function (x) { return !isNaN(parseFloat(x.data.toString())) && isFinite(Number(x.data)) ? Number(x.data) : x.data; })).toArray();
            }
            options.dataProvider = this.getDataProvider();
        }
        else if (baseType == ChartBaseTypes.Gauge) {
            var bands = [];
            var labels = [];
            var start = 25;
            var each = (100 - start) / this.dataEntries.chartDataEntries.length;
            var max = Enumerable.from(this.dataEntries.chartDataEntries).sum(function (x) { return x.data ? Number(x.data) : 0; });
            try {
                for (var _b = __values(this.dataEntries.chartDataEntries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    var index = this.dataEntries.chartDataEntries.indexOf(item);
                    var posStart = start + (index * each);
                    var posEnd = posStart + each;
                    var value = (Number(item.data) / max) * 100;
                    bands.push({
                        color: "#eee",
                        startValue: 0,
                        endValue: 100,
                        radius: "".concat(posEnd - 2, "%"),
                        innerRadius: "".concat(posStart + 2, "%")
                    });
                    bands.push({
                        color: item.color,
                        startValue: 0,
                        endValue: value,
                        radius: "".concat(posEnd - 2, "%"),
                        innerRadius: "".concat(posStart + 2, "%"),
                        balloonText: "".concat(value.toFixed(2), "%")
                    });
                    var lineEach = 31.5 / this.dataEntries.chartDataEntries.length;
                    var percent = ((this.dataEntries.chartDataEntries.length - index) * lineEach);
                    labels.push({
                        text: item.label,
                        x: "48%",
                        y: "".concat(percent, "%"),
                        size: this.fontSize,
                        bold: true,
                        color: item.color,
                        align: "right"
                    });
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            options.axes = [{
                    axisAlpha: 0,
                    tickAlpha: 0,
                    labelsEnabled: false,
                    startValue: 0,
                    endValue: 100,
                    startAngle: 0,
                    endAngle: 270,
                    bands: bands
                }];
            options.allLabels = labels;
            options.graphs = [{ "adaptiveLabelPosition": true }];
        }
    };
    Chart.prototype.getDataProvider = function () {
        var _this = this;
        return this.dataEntries.labels ?
            this.dataEntries.labels.map(function (x) {
                var e_4, _a;
                var date = _this.dateFormat ? moment(x).format(_this.dateFormat) : "Invalid date";
                if (date == "Invalid date") {
                    date = x;
                }
                var data = {
                    label: date
                };
                try {
                    for (var _b = __values(_this.dataEntries.chartDataEntries), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        //get rounded number if data is number
                        data["".concat(item.label, "-data")] = _this.getValueData(item.data[_this.dataEntries.labels.indexOf(x)]);
                        data["".concat(item.label, "-color")] = item.color;
                        data["".concat(item.label, "-formatData")] = (item.formatData ? "".concat(_this.getLocaleFormatValue(item.formatData[_this.dataEntries.labels.indexOf(x)]), " ").concat(x) : (_this.getLocaleFormatValue(data["".concat(item.label, "-data")]) + ' ' + x));
                        data["".concat(item.label, "-formatDataStacked")] = (_this.getLocaleFormatValue(data["".concat(item.label, "-data")]) + ' ' + x);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                return data;
            })
            : Enumerable.from(this.dataEntries.chartDataEntries).where(function (x) { return x.label == "All"; }).concat(Enumerable.from(this.dataEntries.chartDataEntries).where(function (x) { return x.label != "All"; })).toArray();
    };
    //added to rounded number if data is number
    Chart.prototype.getValueData = function (data) {
        if (!isNaN(parseFloat(data)) && isFinite(data)) {
            return (data % 1 === 0 ? Number(data) : Number(data).toFixed(2));
        }
        else {
            return data;
        }
    };
    Chart.prototype.getLocaleFormatValue = function (data) {
        if (!isNaN(parseFloat(data)) && isFinite(data)) {
            return data.toLocaleString();
        }
        else
            return data;
    };
    Chart.prototype.getType = function (type) {
        switch (type) {
            case ChartTypes.Line:
                return "line";
            case ChartTypes.Bar:
            case ChartTypes.HorizontalBar:
            case ChartTypes.StackedHorizontalBar:
            case ChartTypes.StackedBar:
                return "column";
            case ChartTypes.Donut:
                return "donut";
            case ChartTypes.Pie:
                return "pie";
            case ChartTypes.SolidGauge:
                return "gauge";
            case ChartTypes.AreaChart:
                return "line";
        }
        return "";
    };
    Chart.prototype.shuffle = function (array) {
        var currentIndex = array.length, temporaryValue, randomIndex;
        // while there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            // and swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    };
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], Chart.prototype, "dataEntries", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Chart.prototype, "canZoom", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Chart.prototype, "noDataLabel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Chart.prototype, "showNoDataIfZero", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Chart.prototype, "isDefaultLegendVisible", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], Chart.prototype, "colors", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Chart.prototype, "type", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Chart.prototype, "fontSize", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Chart.prototype, "exportEnabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Chart.prototype, "responsive", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Chart.prototype, "formatTooltip", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Chart.prototype, "title", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Chart.prototype, "exportDivId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Chart.prototype, "labelFrequency", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Chart.prototype, "orderBy", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Chart.prototype, "dateFormat", void 0);
    Chart = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element])
    ], Chart);
    return Chart;
}());
export { Chart };
var ChartTypes = /** @class */ (function () {
    function ChartTypes() {
    }
    ChartTypes.Funnel = "Funnel Chart";
    ChartTypes.Line = "Line Chart";
    ChartTypes.StackedBar = "Stacked Bar Chart";
    ChartTypes.StackedHorizontalBar = "Stacked Horizontal Bar Chart";
    ChartTypes.Bar = "Bar Chart";
    ChartTypes.HorizontalBar = "Horizontal Bar Chart";
    ChartTypes.Donut = "Donut Chart";
    ChartTypes.Pie = "Pie Chart";
    ChartTypes.SolidGauge = "Solid Gauge Chart";
    ChartTypes.AreaChart = "Area Chart";
    return ChartTypes;
}());
export { ChartTypes };
var ChartBaseTypes = /** @class */ (function () {
    function ChartBaseTypes() {
    }
    ChartBaseTypes.Funnel = "funnel";
    ChartBaseTypes.Serial = "serial";
    ChartBaseTypes.Pie = "pie";
    ChartBaseTypes.Gauge = "gauge";
    return ChartBaseTypes;
}());
export { ChartBaseTypes };
